module.exports = __webpack_public_path__ + "img/profile.bd54c34a.png";